import { Dispatch, SetStateAction } from 'react';

type SortColumn = {
  sortAscending: number;
  sortDescending: number;
};
type HeaderProps = {
  name: string;
  sort: SortColumn;
};
type Props = {
  header: HeaderProps;
  sortBy: number;
  setSortBy: Dispatch<SetStateAction<number>>;
};

export function ColumnSort({ header, sortBy, setSortBy }: Readonly<Props>) {
  const handleSort = () => {
    if (sortBy === header.sort.sortAscending) {
      setSortBy(header.sort.sortDescending);
    } else {
      setSortBy(header.sort.sortAscending);
    }
  };

  return (
    <th
      scope="col"
      className="px-6 py-3 hover:bg-[lightgray] cursor-pointer"
      onClick={handleSort}
    >
      <div className="flex text-center items-center gap-[10px] justify-center">
        <p>{header.name}</p>
        <span className="text-sm text-gray-400">
          {(sortBy === header.sort.sortDescending && '▼') ||
            (sortBy === header.sort.sortAscending && '▲')}
        </span>
      </div>
    </th>
  );
}
